// extracted by mini-css-extract-plugin
export default {"root":"vmDUFJEh5V8sjS8JOGEf"};